import React, { use, useEffect, useState } from 'react';
import { fetchHiringRequests, GetDemandPlanning, fetchNotifications, fetchHiringManagers, fetchActiveDepartments, GetCandidate } from '../services/apiService';
 
 
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import FlipCard from '../components/FlipCard';
import Select from 'react-select';
import HiringRequestCards from '../components/HiringRequestCards';
import CandidateCardsList from '../components/CandidateCardsList';
import { getDepartmentIdFromToken, getToken, getUserFromToken } from '../services/authService';
import toast from 'react-hot-toast';
import CreateHiringRequestModal from '../components/CreateHiringRequestModal';
 

 

// Executive roles that should see candidates first
const EXECUTIVE_ROLES = ['CEO', 'Chief Finance', 'HR Director', 'Cheif Finance'];

const HomePage = () => {
  const navigate = useNavigate();
  const [hiringRequests, setHiringRequests] = useState([]);
  const [allHiringRequests, setAllHiringRequests] = useState([]); // Store all hiring requests for role text lookup
  const [demandPlans, setDemandPlans] = useState([]);
  const [allDemandPlans, setAllDemandPlans] = useState([]); // Store all demand plans for role lookup
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [hiringManagers, setHiringManagers] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [visibleCount, setVisibleCount] = useState(8);
  const [userRole, setUserRole] = useState({});
  const [active, setActive] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [waitingActionsSubTab, _setWaitingActionsSubTab] = useState(() => sessionStorage.getItem('homeActiveTab') || null);
  const setWaitingActionsSubTab = (tab) => {
    sessionStorage.setItem('homeActiveTab', tab);
    _setWaitingActionsSubTab(tab);
  };
  const [candidates, setCandidates] = useState([]);
 

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#fff',
      borderRadius: '0.75rem',
      borderColor: state.isFocused ? '#124c72' : 'rgba(18, 76, 114, 0.3)',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
      padding: '2px 8px',
      cursor: 'pointer',
      minHeight: '38px',
      color: '#124c72',
      '&:hover': {
        borderColor: '#124c72'
      }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '0.75rem',
      backgroundColor: 'white',
      boxShadow: '0 10px 25px rgba(18, 76, 114, 0.15)',
      zIndex: 1000,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'rgba(18, 76, 114, 0.1)' : state.isFocused ? 'rgba(18, 76, 114, 0.05)' : 'white',
      color: '#124c72',
      cursor: 'pointer',
      padding: '8px 12px',
    }),
    singleValue: (provided) => ({ 
      ...provided, 
      color: '#124c72', 
      fontWeight: '600' 
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'rgba(18, 76, 114, 0.6)',
      ':hover': { color: '#124c72' },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(18, 76, 114, 0.5)',
    }),
  };

  // Helper function to check if user is an executive role
  const isExecutiveRole = (role) => {
    if (!role) return false;
    const roleName = typeof role === 'string' ? role : role.role;
    if (!roleName) return false;
    return EXECUTIVE_ROLES.some(execRole => 
      roleName.toLowerCase().trim() === execRole.toLowerCase().trim()
    );
  };

  // Helper function to get role text for a candidate
  const getRoleTextForCandidate = (candidate) => {
    if (!candidate || !candidate.request_id) return '';
    
    // Find matching hiring request (use allHiringRequests to ensure we have all data)
    const matchingRequest = allHiringRequests.find(
      req => String(req.request_id) === String(candidate.request_id)
    );
    
    console.log('Candidate request_id:', candidate.request_id);
    console.log('Matching Request:', matchingRequest);
    
    if (!matchingRequest) return '';
    
    // If Exceptional request, return role_text
    if (matchingRequest.request_type === "Exceptional") {
      console.log('Exceptional - role_text:', matchingRequest.role_text);
      return matchingRequest.role_text || '';
    }
    
    // Otherwise find demand plan and return role
    if (matchingRequest.demand_id) {
      const matchingDemandPlan = allDemandPlans.find(
        plan => String(plan.demand_id) === String(matchingRequest.demand_id)
      );
      console.log('Matching Demand Plan:', matchingDemandPlan);
      if (matchingDemandPlan) {
        return matchingDemandPlan.role || '';
      }
    }
    
    return '';
  };
 const getReqTypeTextForCandidate = (candidate) => {
  if (!candidate || !candidate.request_id) return '';

  // Find matching hiring request
  const matchingRequest = allHiringRequests.find(
    req => String(req.request_id) === String(candidate.request_id)
  );

  console.log('Candidate request_id:', candidate.request_id);
  console.log('Matching Request:', matchingRequest);

  if (!matchingRequest) return '';

  return matchingRequest.request_type || '';
};
  useEffect(() => {
    const token = getToken();
    if (!token) return;
    
    const getData = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const role = getToken();
        setUserRole(role);
        const departmentId = getDepartmentIdFromToken();
        const userName = getUserFromToken();
         const userId = role.user_id; // make sure your token has this
        // Debug: Log the role to see its structure
        console.log('User Role:', role);
        console.log('Role name:', role?.role);
        console.log('Is Executive:', isExecutiveRole(role));
        
        const [hiringRequestsData, demandPlansData, notificationsData, deptData, managers, candidatesData] = await Promise.all([
          fetchHiringRequests(),
          GetDemandPlanning(currentYear),
          fetchNotifications(role.role, userName),
          fetchActiveDepartments(),
          fetchHiringManagers(),
          GetCandidate()
        ]);

        // Store ALL hiring requests and demand plans for role text lookup
        setAllHiringRequests(hiringRequestsData);
        setAllDemandPlans(demandPlansData);

        setHiringManagers(managers);

        // Filter Candidates
const allowedStatuses = ["Send For Initial Approval", "Send For Approval"];

let filteredCandidates = candidatesData.filter(candidate =>
  (candidate.approval_level_name === role.role && allowedStatuses.includes(candidate.status)) ||
  (candidate.status === "Ready For Evaluation" && role.role === "Business Owner") ||
  (candidate.status === "Under Evaluation")
);



        
        if(role.role === "Business Owner"){
          if (role.IsDepartmentRestricted === "True") {
            filteredCandidates = filteredCandidates.filter(
              (candidate) => String(candidate.department_id) === String(departmentId)
            );
          }
        }
        
        setCandidates(filteredCandidates);
       let filteredRequests = hiringRequestsData;

if (role.role !== "Finance Manager" && role.role !== "CEO")
 {
        // Filter Hiring Requests for display
  filteredRequests= role.IsDepartmentRestricted === "True"
  ? hiringRequestsData.filter(req => String(req.department_id) === String(departmentId))
  : hiringRequestsData.filter(req => req.isDepartmentRestricted ? req.status !== "Draft" : true);
}

if (role.role === "HR Specialist") {
  const uid = Number(userId);

  filteredRequests = filteredRequests.filter(
    req => req.recruiter_id === uid  
  );
}

if (role.role === "Finance Manager") {
  filteredRequests = filteredRequests.filter(req => {
    const needsApproval = req.isFinanceManagerApproveRequired === true && req.isFinanceManagerApproved === null && (req.status==="Submitted" || req.status==="Approved");
    const sameDepartment = String(req.department_id) === String(departmentId);
    return needsApproval || sameDepartment;
  });
}


if (role.role === "CEO") {
  filteredRequests = filteredRequests.filter(req => {
    // Requests waiting for CEO approval
    const needsCEOApproval = req.isFinanceManagerApproveRequired === true && req.isHRDirectorApproved === true && req.isCEOApproved !== true && req.status === "Approved";
    // Requests created by CEO (as Business Owner)
    const isOwnRequest = Number(req.hiring_manager) === Number(userId);
    return needsCEOApproval || isOwnRequest;
  });
}





    
        setHiringRequests(filteredRequests);

        // Filter Demand Plans for display
        setDemandPlans(role.IsDepartmentRestricted === "True"
          ? demandPlansData.filter(plan => String(plan.department_id) === String(departmentId))
          : demandPlansData
        );

        // Filter Notifications
        setNotifications(role.IsDepartmentRestricted === "True"
          ? notificationsData.filter(n => String(n.department_id) === String(departmentId))
          : notificationsData
        );

        // Filter Departments
        if (role.role !== "Finance Manager") {
  setDepartments(role.IsDepartmentRestricted === "True"
    ? deptData.filter(d => String(d.department_id) === String(departmentId))
    : deptData
  );
} else {
  setDepartments(deptData);
}
        // Set default sub-tab to first tab with data
        // Will be updated after render when subTabs are computed

      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("There was an error loading the data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    getData();
  }, []);

  // Function to refresh hiring requests after creating a new one
  const refreshHiringRequests = async () => {
    try {
      const currentYear = new Date().getFullYear();
      const role = getToken();
      const departmentId = getDepartmentIdFromToken();
      
      const [hiringRequestsData, demandPlansData] = await Promise.all([
        fetchHiringRequests(),
        GetDemandPlanning(currentYear)
      ]);

      // Update all data stores
      setAllHiringRequests(hiringRequestsData);
      setAllDemandPlans(demandPlansData);

      // Filter Hiring Requests for display
      const filteredRequests = role.IsDepartmentRestricted === "True"
        ? hiringRequestsData.filter(req => String(req.department_id) === String(departmentId))
        : hiringRequestsData.filter(req => req.isDepartmentRestricted ? req.status !== "Draft" : true);
      
      setHiringRequests(filteredRequests);

      // Update demand plans if needed
      setDemandPlans(role.IsDepartmentRestricted === "True"
        ? demandPlansData.filter(plan => String(plan.department_id) === String(departmentId))
        : demandPlansData
      );

    } catch (error) {
      console.error("Error refreshing data:", error);
      toast.error("Failed to refresh data");
    }
  };

  // Check if current user is an executive role
  const userIsExecutive = isExecutiveRole(userRole);

  // Auto-select first available tab — only if no saved tab
  useEffect(() => {
    if (isLoading) return;
    const saved = sessionStorage.getItem('homeActiveTab');
    if (saved) return; // preserve saved tab from previous navigation
    if (hiringRequests.length > 0) {
      setWaitingActionsSubTab('hiringRequests');
    } else if (candidates.length > 0) {
      setWaitingActionsSubTab('candidates');
    }
  }, [isLoading]);

  if (isLoading) return <LoadingSpinner label="Loading Home" />;

  // Show hiring requests for all users
  const shouldShowHiringRequests = true;

  const filteredHiringRequests = shouldShowHiringRequests ? hiringRequests.filter(req => {
    // Filter by department
    return selectedDepartment && selectedDepartment !== 'all'
      ? Number(req.department_id) === Number(selectedDepartment)
      : true;
  }) : [];

  // Get hiring requests waiting for action (only Submitted status)
let waitingActionRequests = []; // Declare first

if (['Admin', 'HR Manager', 'HR Specialist'].includes(userRole.role)) {
  waitingActionRequests = shouldShowHiringRequests
    ? hiringRequests
    : [];

} else if (userRole.role === "HR Director") {
  waitingActionRequests = shouldShowHiringRequests
    ? hiringRequests.filter(req => {
        // Forecast: pending HR Director approval
        const forecastPending = req.status === "Submitted" && req.request_type === "Forecast";
        // Exceptional/Outsourced: pending HR Director approval in chain
        const excPendingApproval = (req.request_type === "Exceptional" || req.request_type === "Outsourced") &&
          !!req.isFinanceManagerApproved && !req.isHRDirectorApproved;
        // Fully approved: ready for convert to sourcing
        const readyForSourcing = req.status === "Approved" && !req.isConevrtToSource &&
          (req.request_type === "Forecast" ||
          (!!req.isFinanceManagerApproved && !!req.isHRDirectorApproved && !!req.isCEOApproved));
        return forecastPending || excPendingApproval || readyForSourcing;
      })
    : [];

} else {

  if (userRole.role === "Finance Manager") {

    waitingActionRequests = shouldShowHiringRequests
      ? hiringRequests.filter(req => {

          const needsApproval =
            req.isFinanceManagerApproveRequired === true &&
            req.isFinanceManagerApproved === null &&
            (req.status === "Submitted" || req.status === "Approved");

          const isDraft = req.status === "Draft";

          return needsApproval || isDraft;
        })
      : [];

  } else if (userRole.role === "HR Director") {

    waitingActionRequests = shouldShowHiringRequests
      ? hiringRequests.filter(req => {
          // Exceptional/Outsourced: pending HR Director approval in chain
          const needsChainApproval = req.isFinanceManagerApproveRequired === true &&
            req.isFinanceManagerApproved === true &&
            req.isHRDirectorApproved !== true &&
            req.status === "Approved";
          // Forecast: HR Director approves Submitted requests
          const needsForecastApproval = req.status === "Submitted" &&
            req.request_type === "Forecast";
          return needsChainApproval || needsForecastApproval;
        })
      : [];

  } else if (userRole.role === "CEO") {

    waitingActionRequests = shouldShowHiringRequests
      ? hiringRequests.filter(req => {
          const needsApproval = req.isFinanceManagerApproveRequired === true &&
            req.isHRDirectorApproved === true &&
            req.isCEOApproved !== true &&
            req.status === "Approved";
          return needsApproval;
        })
      : [];

  } else {

    waitingActionRequests = shouldShowHiringRequests
      ? hiringRequests.filter(req => req.status === "Draft")
      : [];

  }
}


  // Bar chart data - using blue color scheme (no orange)
  const departmentData = demandPlans.reduce((acc, plan) => {
    const department = departments.find(d => String(d.department_id) === String(plan.department_id))?.department_name || 'Other';
    acc[department] = (acc[department] || 0) + plan.forecasted_hires;
    return acc;
  }, {});

  const barChartData = {
    labels: Object.keys(departmentData),
    datasets: [{ 
      label: 'Forecasted Hires', 
      data: Object.values(departmentData), 
      backgroundColor: 'rgba(18, 76, 114, 0.8)',
      borderColor: '#124c72',
      borderWidth: 1,
      borderRadius: 4,
      hoverBackgroundColor: 'rgba(18, 76, 114, 0.6)',
    }],
  };

  // Pie chart data - using blue color scheme (no orange)
  const statusData = hiringRequests.reduce((acc, req) => {
    const status = req.status || 'Draft';
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const pieChartColors = [
    '#124c72', // Dark blue
    'rgba(18, 76, 114, 0.85)', // Slightly lighter blue
    'rgba(18, 76, 114, 0.7)', // Medium blue
    'rgba(18, 76, 114, 0.55)', // Light blue
    'rgba(18, 76, 114, 0.4)', // Lighter blue
    'rgba(18, 76, 114, 0.25)', // Very light blue
    'rgba(18, 76, 114, 0.15)', // Extra light blue
  ];

  const pieChartData = {
    labels: Object.keys(statusData),
    datasets: [{ 
      label: 'Hiring Status', 
      data: Object.values(statusData), 
      backgroundColor: pieChartColors,
      borderColor: 'white',
      borderWidth: 2,
      hoverOffset: 8
    }],
  };

  const handleNotificationAction = (notificationId, recipientId) => {
    navigate('/candidate-details', { state: { id: recipientId } });
  };

  // Get ordered sub-tabs based on user role - Executives see Candidates FIRST
  const getSubTabsOrder = () => {
    if (userIsExecutive) {
      // For executives (CEO, Chief Finance, HR Director): Candidates first
      return [
        { key: 'candidates', label: 'Candidates', count: candidates.length },
        { key: 'awaitingAction', label: 'Awaiting Action', count: waitingActionRequests.length },
        { key: 'hiringRequests', label: 'All Hiring Requests', count: filteredHiringRequests.length },
      ];
    }
    // Default order for other roles
    return [
      { key: 'awaitingAction', label: 'Awaiting Action', count: waitingActionRequests.length },
      { key: 'hiringRequests', label: 'All Hiring Requests', count: filteredHiringRequests.length },
      { key: 'candidates', label: 'Candidates', count: candidates.length },
    ];
  };

  const subTabs = getSubTabsOrder().filter(tab => tab.count > 0).filter((tab, _, arr) => {
    if (tab.key === 'awaitingAction') {
      const allReq = arr.find(t => t.key === 'hiringRequests');
      if (allReq && allReq.count === tab.count) return false;
    }
    return true;
  });

  // Get ordered summary cards based on user role
  const getSummaryCardsOrder = () => {
    if (userIsExecutive) {
      // For executives: Candidates first with highlight
      return [
        { key: 'candidates', label: 'Candidates', count: candidates.length, description: 'Candidates awaiting your review', isHighlighted: true },
        { key: 'awaitingAction', label: 'Awaiting Action', count: waitingActionRequests.length, description: 'Requests requiring your review', isHighlighted: false },
        { key: 'hiringRequests', label: 'All Hiring Requests', count: filteredHiringRequests.length, description: 'Total active requests', isHighlighted: false },
      ];
    }
    // Default order for other roles
    return [
      { key: 'awaitingAction', label: 'Awaiting Action', count: waitingActionRequests.length, description: 'Requests requiring your review', isHighlighted: true },
      { key: 'hiringRequests', label: 'All Hiring Requests', count: filteredHiringRequests.length, description: 'Total active requests', isHighlighted: false },
      { key: 'candidates', label: 'Candidates', count: candidates.length, description: 'Candidates awaiting review', isHighlighted: false },
    ];
  };

  const summaryCards = getSummaryCardsOrder().filter(card => card.count > 0).filter((card, _, arr) => {
    // If Awaiting Action and All Hiring Requests have same count, keep only All Hiring Requests
    if (card.key === 'awaitingAction') {
      const allReq = arr.find(c => c.key === 'hiringRequests');
      if (allReq && allReq.count === card.count) return false;
    }
    return true;
  });

  return (
    <div className="relative min-h-screen">
      {/* KPI Section */}
      <div className="xl:absolute z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-8 -top-4 sm:-top-6 lg:-top-[70px] lg:px-[2.5%] 3xl:px-[8%] 4xl:px-[10%]">
        <FlipCard
          label="Total Hiring"
          count={hiringRequests.length}
          imgSrc="/total-request.svg"
          filter="all"
        />
        <FlipCard
          label="HR Pending"
          count={hiringRequests.filter(req => {
            const forecastPending = req.status === "Submitted" && req.request_type === "Forecast";
            const excPendingHRDir = (req.request_type === "Exceptional" || req.request_type === "Outsourced") &&
              !!req.isFinanceManagerApproved && !req.isHRDirectorApproved;
            return forecastPending || excPendingHRDir;
          }).length}
          imgSrc="/pending.svg"
          filter="hr-pending"
        />
        <FlipCard
          label="Total Sourcing"
          count={hiringRequests.filter(req => req.isConevrtToSource === true).length}
          imgSrc="/sourcing.svg"
          filter="sourcing"
        />
        <FlipCard
          label="Waiting For Hiring"
          count={
            hiringRequests.filter(req =>
              ["Under Hiring Process", "Send For Approval"].includes(req.status)
            ).length
          }
          imgSrc="/add-employee.svg"
          filter="waiting-hiring"
        />

        {/* Create New Request Button */}
        <div 
          onClick={() => setShowCreateModal(true)} 
          className="cursor-pointer"
        >
          <div 
            className="w-full bg-center bg-cover p-8 text-center rounded-2xl hover:opacity-90 transition-opacity duration-200" 
            style={{ backgroundImage: `url('/add-bg.png')` }}
          >
            <div className='flex flex-col gap-4 items-center'>
              <img src='/add.svg' className='w-[40px]' alt="Add icon" />
              <label className='font-bold text-xl text-white cursor-pointer'>Create New Request</label>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="
        bg-white
        mx-4
        sm:h-[72vh] sm:pt-4 sm:px-4 sm:rounded-t-[32px]
        md:h-[74.5vh] md:pt-8 md:px-[calc(5%-1rem)] md:rounded-t-[40px]
        lg:h-[74.5vh] lg:px-[calc(6%-1rem)]
        xl:h-[100%] xl:pt-24 xl:px-[calc(2.5%-1rem)] xl:rounded-t-[48px]
        2xl:h-[74.5vh] 2xl:px-[calc(8%-1rem)]
        3xl:h-[74.5vh] 3xl:px-[calc(8%-1rem)]
        4xl:h-[74.5vh] 4xl:px-[calc(10%-1rem)]
      ">
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 min-h-0'>
          
          {/* Waiting Actions / Awaiting Action - Takes 2 columns on large screens */}
          {subTabs.length > 0 && (
          <div className="lg:col-span-2 bg-white rounded-2xl filter drop-shadow-[0_10px_25px_rgba(18,76,114,0.1)]
              flex flex-col min-h-0 h-full border border-[rgba(18,76,114,0.1)]">
            
            {/* Fixed Header Section with Sub-tabs */}
            <div className="flex flex-col p-4 flex-shrink-0 border-b border-[rgba(18,76,114,0.1)]">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4" style={{ color: '#124c72' }}>
                Waiting Actions
              </h3>
              
              {/* Sub-tabs - Dynamic order based on role */}
              <div className="flex gap-2 mb-4 overflow-x-auto">
                {subTabs.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setWaitingActionsSubTab(tab.key)}
                    className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap
                      ${waitingActionsSubTab === tab.key
                        ? "text-white"
                        : "text-[rgba(18,76,114,0.7)] hover:text-[#124c72]"
                      }`}
                    style={{
                      backgroundColor: waitingActionsSubTab === tab.key ? '#124c72' : 'rgba(18, 76, 114, 0.05)',
                      border: waitingActionsSubTab === tab.key ? '1px solid #124c72' : '1px solid rgba(18, 76, 114, 0.1)'
                    }}
                  >
                    {tab.label} ({tab.count})
                  </button>
                ))}
              </div>

              {/* Department Filter - Show only for hiringRequests sub-tab */}
              {waitingActionsSubTab === 'hiringRequests' && userRole.role !== 'CEO' && (
                <div className='flex flex-col sm:flex-row gap-4 w-full sm:w-auto'>
                  <div className="w-full sm:w-48">
                    <Select
                      options={[{ value: 'all', label: 'Select Department' }, ...departments.map(d => ({ value: d.department_id, label: d.department_name }))]}
                      value={selectedDepartment === 'all'
                        ? { value: 'all', label: 'Select Department' }
                        : departments.find(d => Number(d.department_id) === Number(selectedDepartment))
                          ? { value: selectedDepartment, label: departments.find(d => Number(d.department_id) === Number(selectedDepartment))?.department_name }
                          : { value: 'all', label: 'Select Department' }
                      }
                      onChange={option => setSelectedDepartment(option.value)}
                      placeholder="Select Department"
                      styles={customSelectStyles}
                      aria-label="Select Department"
                    />
                  </div>

                  {filteredHiringRequests.length > visibleCount && (
                    <button
                      onClick={() => navigate('/all-hiring-request')}
                      className="px-6 py-2 bg-primary-600 text-white rounded-3xl shadow hover:bg-primary-800 transition duration-200 w-full sm:w-auto"
                    >
                      View More
                    </button>
                  )}
                </div>
              )}
            </div>

            {/* Scrollable Content Area */}
            <div className="flex-1 min-h-0 overflow-y-auto p-4">
              {waitingActionsSubTab === 'awaitingAction' ? (
                waitingActionRequests.length > 0 ? (
                  <HiringRequestCards
                    filteredHiringRequests={waitingActionRequests}
                    demandPlans={demandPlans}
                    hiringManagers={hiringManagers}
                    visibleCount={visibleCount}
                    departments={departments}
                  />
                ) : (
                  <div className="text-center py-12" style={{ color: 'rgba(18, 76, 114, 0.5)' }}>
                    <svg 
                      className="mx-auto h-12 w-12 mb-4" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                      style={{ color: 'rgba(18, 76, 114, 0.3)' }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-lg font-medium">No hiring requests awaiting action</p>
                    <p className="text-sm mt-1">All requests have been processed</p>
                  </div>
                )
              ) : waitingActionsSubTab === 'hiringRequests' ? (
                <HiringRequestCards
                  filteredHiringRequests={filteredHiringRequests}
                  demandPlans={demandPlans}
                  hiringManagers={hiringManagers}
                  visibleCount={visibleCount}
                  departments={departments}
                />
              ) : waitingActionsSubTab === 'candidates' ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
                  {candidates.length > 0 ? (
                    candidates.map(candidate => {
                      const department = departments.find(d => String(d.department_id) === String(candidate.department_id));
                      const displayName = candidate.full_name || candidate.candidate_name || 'N/A';
                      const displayStatus = candidate.approval_status || candidate.status || 'Pending';
                      const roleText = getRoleTextForCandidate(candidate);
                       const requesttype = getReqTypeTextForCandidate(candidate);
                      return (
                        <div 
                          key={candidate.candidate_id}
                          className="bg-white rounded-xl border border-[rgba(18,76,114,0.15)] hover:border-[#124c72] transition-all cursor-pointer hover:shadow-lg overflow-hidden"
                          onClick={() => navigate('/candidate-details', { state: { id: candidate.candidate_id } })}
                          style={{
                            boxShadow: '0 2px 8px rgba(18, 76, 114, 0.08)'
                          }}
                        >
                          {/* Status Header Bar */}
                          <div className="px-4 py-3 flex items-center justify-between" style={{ backgroundColor: 'rgba(18, 76, 114, 0.08)' }}>
                            <span className="text-xs font-semibold uppercase tracking-wide" style={{ color: '#124c72' }}>
                              {displayStatus}
                            </span>
                            <svg className="w-4 h-4" style={{ color: '#124c72' }} fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                            </svg>
                          </div>

                          {/* Card Content */}
                          <div className="p-4">
                            {/* Avatar and Name */}
                            <div className="flex items-center gap-3 mb-4">
                              <img
                                src={
                                  candidate.profile_picture ||
                                  `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=124c72&color=fff&bold=true`
                                }
                                alt={displayName}
                                className="w-12 h-12 rounded-full object-cover border-2 shadow-sm"
                                style={{ borderColor: '#124c72' }}
                              />
                              <div className="flex-1 min-w-0">
                                <h4 className="font-bold text-base mb-0.5 truncate" style={{ color: '#124c72' }}>
                                  {displayName}
                                </h4>
                                <p className="text-xs truncate" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>
                                  {roleText || candidate.position_title || 'Position not specified'}
                                </p>
                              </div>
                            </div>

                            {/* Info Grid */}
                            <div className="space-y-2.5 mb-4">
                              {/* Department */}
                              <div className="flex items-center gap-2">
                                <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                  <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                  </svg>
                                </div>
                                <span className="text-xs font-medium truncate" style={{ color: '#124c72' }}>
                                  {candidate?.department_name || 'N/A'}
                                </span>
                              </div>

                              {/* Email */}
                              {candidate.email && (
                                <div className="flex items-center gap-2">
                                  <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                    <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                  </div>
                                  <span className="text-xs truncate" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                                    {candidate.email}
                                  </span>
                                </div>
                              )}

                              {/* Phone */}
                              {candidate.phone_number && (
                                <div className="flex items-center gap-2">
                                  <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                    <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                  </div>
                                  <span className="text-xs" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                                    {candidate.phone_number}
                                  </span>
                                </div>
                              )}

                              {/* Experience */}
                              <div className="flex items-center gap-2">
                                <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                  <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                  </svg>
                                </div>
                                <span className="text-xs" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                                  {candidate.experience_years || '0'} years experience
                                </span>
                              </div>

                              {/* Position */}
                              {candidate.last_job_title && (
                              <div className="flex items-center gap-2">
                                <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                  <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                  </svg>
                                </div>
                                <span className="text-xs truncate" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                                  {candidate.last_job_title}
                                </span>
                              </div>
                              )}

                              {/* Approval Level */}
                              {requesttype && (
                                <div className="flex items-center gap-2">
                                  <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                                    <svg className="w-3 h-3" style={{ color: '#124c72' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                    </svg>
                                  </div>
                                  <span className="text-xs truncate" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                                    {requesttype}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Action Button */}
                            <button
                              className="w-full py-2.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90 flex items-center justify-center gap-2"
                              style={{ 
                                backgroundColor: '#124c72',
                                color: 'white',
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate('/candidate-details', { state: { id: candidate.candidate_id } });
                              }}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              </svg>
                              Review Candidate
                            </button>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-span-full text-center py-12" style={{ color: 'rgba(18, 76, 114, 0.5)' }}>
                      <svg 
                        className="mx-auto h-12 w-12 mb-4" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                        style={{ color: 'rgba(18, 76, 114, 0.3)' }}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      <p className="text-lg font-medium">No candidates awaiting approval</p>
                      <p className="text-sm mt-1">All candidates have been reviewed</p>
                    </div>
                  )}
                </div>
              ) : (
                // Notifications tab
                <div className="flex flex-col gap-4">
                  {notifications.length > 0 ? (
                    notifications.map(notif => (
                      <div 
                        key={notif.notificationID} 
                        className="p-4 rounded-lg border border-[rgba(18,76,114,0.1)] hover:border-[rgba(18,76,114,0.3)] transition-colors"
                        style={{ backgroundColor: 'rgba(18, 76, 114, 0.03)' }}
                      >
                        <div className="mb-3 text-sm" style={{ color: 'rgba(18, 76, 114, 0.8)' }}>
                          {notif.message}
                        </div>
                        <button
                          className="px-4 py-2 rounded-lg transition-all font-medium hover:opacity-90"
                          style={{ 
                            backgroundColor: '#124c72',
                            color: 'white',
                            boxShadow: '0 4px 6px rgba(18, 76, 114, 0.2)'
                          }}
                          onClick={() => handleNotificationAction(notif.notificationID, notif.recipientID)}
                        >
                          View
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-12" style={{ color: 'rgba(18, 76, 114, 0.5)' }}>
                      <svg 
                        className="mx-auto h-12 w-12 mb-4" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                        style={{ color: 'rgba(18, 76, 114, 0.3)' }}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                      </svg>
                      <p className="text-lg font-medium">No notifications</p>
                      <p className="text-sm mt-1">You're all caught up!</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          )}

          {/* Right Panel - Quick Approvals, Charts, etc. */}
          <div className="lg:col-span-1 flex flex-col gap-6 min-h-0">
            
            {/* Tab Navigation - Hide Waiting Actions tab for excluded roles */}
           

            {/* Tab Content Container */}
            <div className="flex-1 min-h-0">
              {active === 0 && shouldShowHiringRequests && summaryCards.length > 0 && (
                <div className="bg-white rounded-lg filter drop-shadow-[0_10px_25px_rgba(18,76,114,0.1)] 
                    flex flex-col h-full border border-[rgba(18,76,114,0.1)]">
                  
                  {/* Quick Summary for Waiting Actions */}
                  <div className="p-4 border-b border-[rgba(18,76,114,0.1)] flex-shrink-0">
                    <h3 className="text-xl sm:text-2xl font-semibold" style={{ color: '#124c72' }}>
                      Actions Summary
                    </h3>
                  </div>
                  
                  {/* Summary Cards - Dynamic order based on role */}
                  <div className="flex-1 min-h-0 overflow-y-auto p-4">
                    <div className="grid grid-cols-1 gap-4">
                      {summaryCards.map((card) => (
                        <div
                          key={card.key}
                          className="p-6 rounded-lg cursor-pointer transition-all hover:shadow-lg border"
                          style={{
                            backgroundColor: waitingActionsSubTab === card.key ? 'rgba(18, 76, 114, 0.08)' : 'rgba(18, 76, 114, 0.02)',
                            borderColor: waitingActionsSubTab === card.key ? '#124c72' : 'rgba(18, 76, 114, 0.1)'
                          }}
                          onClick={() => setWaitingActionsSubTab(card.key)}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <h4 className="font-semibold text-lg" style={{ color: '#124c72' }}>
                              {card.label}
                            </h4>
                            <span 
                              className="text-2xl font-bold"
                              style={{ color: '#124c72' }}
                            >
                              {card.count}
                            </span>
                          </div>
                          <p className="text-sm" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>
                            {card.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              
            </div>
          </div>
        </div>
      </div>

      {/* Create Hiring Request Modal */}
      <CreateHiringRequestModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={refreshHiringRequests}
      />
    </div>
  );
};

export default HomePage;